import React from 'react'
import { getIn } from 'formik'

import Dv360MediaUpload from '../Dv360MediaUpload'

import { useMultipleMediaUpload } from '../../../../../../../ReusableFormFields/AdFileUpload/hooks/useMultipleMediaUpload'

import { initialDv360File, MEDIA_ITEMS } from '../../../Routes/CreativeFileUploadRoute/fields'

const MultipleDv360MediaUpload = ({ formik, FileItemPath, fileValidationSchema }) => {
  const { values, setValues } = formik

  const carouselItems = getIn(values, FileItemPath)
  const maxCount = 10

  const { handleAddAnotherItem, handleDeleteItem } = useMultipleMediaUpload({
    carouselItems,
    maxCount,
    FileItemPath,
    initialFileValue: initialDv360File,
    setValues,
    values
  })

  return (
    <>
      {carouselItems.map((ad, index) => {
        const itemPath = `${MEDIA_ITEMS}[${index}]`
        return (
          <Dv360MediaUpload
            formik={formik}
            itemPath={itemPath}
            onMediaRemove={() => handleDeleteItem(index)}
            onMediaStartUpload={handleAddAnotherItem}
            index={index}
            key={ad.id}
            fileValidationSchema={fileValidationSchema}
            allowMultipleFiles
          />
        )
      })}
    </>
  )
}

export default MultipleDv360MediaUpload
